<template>
    <div>
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :request-query-string-params="autocompleteQueryStringParams.material"
                        :repository="repositories.material"
                        :search-fields="autocompleteFields.material"
                        :validations="validations.material"
                        label="Material"
                        text-field="descricaoCompleta"
                        uppercase
                        v-model="model.material"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="model.estoque"
                        disabled
                        label="Estoque"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :disabled="!model.material || !temEstoque"
                        :validations="validations.quantidade"
                        label="Quantidade"
                        v-model="model.quantidade"
                        type="number"
                    >
                        <rkm-input-group-append
                            v-if="model.material && possuiEntradaComLote"
                            slot="append"
                        >
                            <rkm-button
                                :disabled="!quantidadeValida"
                                @click.stop="$refs.ModalLote.open(model.entradaItens)"
                                title="Visualizar lotes"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="box-open" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :disabled="!(!model.material || (model.material && temEstoque))"
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalLote
            :model="model"
            ref="ModalLote"
        />
    </div>
</template>

<script>
// Components
import ModalLote from '@/components/almoxarifado/components/lote/Modal'

// Mixins.
import { repository, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalLote },
    computed: {
        temEstoque() {

            return this.model.estoque > 0
        },
        quantidadeValida() {

            if (!this.model.quantidade) {

                return false
            }

            const quantidade = parseInt(this.model.quantidade)

            return quantidade > 0 && quantidade <= this.model.estoque
        },
        autocompleteFields() {

            return {
                material: [
                    { key: 'almoxarifado_entrada_item.codigo_barras', searchable: true },
                    { key: 'cadastro_material.codigo_material', searchable: true },
                    { key: 'cadastro_material.descricao', searchable: true },
                ],
            }
        },
        autocompleteQueryStringParams() {

            return {
                material: {
                    almoxarifado_check_controle_estoque: true,
                    not_id: this.data.model.itens.filter(i => !i.estornado).map(i => i.material.id),
                }
            }
        },
        validations() {

            return {
                material: {
                    required: true,
                },
                quantidade: {
                    required: true,
                    min_value: 1,
                    max_value: this.model.estoque,
                },
            }
        },
    },
    created() {

        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
        }
    },
    data: () => ({
        model: {
            id: null,
            material: null,
            estoque: 0,
            quantidade: null,
            estornoSalvo: false,
            estornado: false,
            escolheuEntradaItemManualmente: false,
            entradaItens: [],
        },
        possuiEntradaComLote: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            const item = this.clone(this.model)

            delete item.estoque

            item.quantidade = parseInt(item.quantidade)

            item.entradaItens = item.entradaItens.map(e => ({
                entradaItemId: e.entradaItemId,
                quantidadeSaida: isNaN(parseInt(e.quantidadeSaida)) ? 0 : parseInt(e.quantidadeSaida),
            }))

            this.data.model.itens.push(item)
            this.resetForm()
        },
        resetForm() {

            this.possuiEntradaComLote = false

            this.model.id = null
            this.model.material = null
            this.model.estornoSalvo = false
            this.model.estornado = false

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        loadEstoque() {

            this.setLoading()

            this.repositories.material.getEstoque(this.model.material.id)
                .then(({ data }) => {

                    this.possuiEntradaComLote = data.possuiEntradaComLote
                    this.model.estoque = data.total

                    this.model.entradaItens = data.porEntrada.map(estoqueEntrada => {

                        estoqueEntrada.quantidadeSaida = 0

                        return estoqueEntrada
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectEntradaItens() {

            this.model.escolheuEntradaItemManualmente = false

            this.model.entradaItens.map(e => e.quantidadeSaida = 0)

            let quantidade = parseInt(this.model.quantidade)
            let i = 0

            while (quantidade > 0) {

                const entradaItem = this.model.entradaItens[i]
                const estoque = parseInt(entradaItem.estoque)

                if (quantidade > estoque) {

                    entradaItem.quantidadeSaida = estoque
                    quantidade -= estoque
                }
                else {

                    entradaItem.quantidadeSaida = quantidade
                    quantidade = 0
                }

                i++
            }
        }
    },
    mixins: [ repository, object ],
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'model.material': function (material) {

            this.model.estoque = 0
            this.model.entradaItens = []
            this.model.escolheuEntradaItemManualmente = false
            this.model.quantidade = null

            if (material) {

                this.loadEstoque()
            }
        },
        'model.quantidade': function () {

            if (this.model.material && this.possuiEntradaComLote && this.quantidadeValida) {

                this.selectEntradaItens()
            }
        },
    }
}
</script>